<template>
  <ul class="list-reset list-stars">
    <li>
      <div class="text">5 * - {{ group[5] ?? 0 }} %</div>
      <!-- <div class="bar">
        <div
          class="progress"
          v-if="group[5]"
          :style="{ width: group[5] + '%' }"
        ></div>
        <div class="progress" style="width: 0%" v-else></div>
      </div> -->
    </li>
    <li>
      <div class="text">4 * - {{ group[4] ?? 0 }} %</div>
    </li>
    <li>
      <div class="text">3 * - {{ group[3] ?? 0 }} %</div>
    </li>
    <li>
      <div class="text">2 * - {{ group[2] ?? 0 }} %</div>
    </li>
    <li>
      <div class="text">1 * - {{ group[1] ?? 0 }} %</div>
    </li>
  </ul>
</template>

<script>
export default {
  props: ["group"],
};
</script>
